import React from 'react';

const WhyChoose = () => {

    const style = {
        color: '#6D214F',
        marginBottom: '20px',
    }

    return (
        <div className="container-fluid p-3">
            <div className="p-3 text-center">
                <h2 style={style} className="display-5">Why Choose Us?</h2>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo tenetur dolores deserunt libero consectetur dolorem placeat magni odio pariatur. Hic nostrum cum ut earum aspernatur dolor ipsa eius minima neque odit optio, possimus autem dolores provident similique fugiat! Quod voluptate, accusamus earum est vero esse voluptates dicta provident veniam hic, corporis omnis illum dolore assumenda at deleniti ad ut in!
                </p>
            </div>
        </div>
    );
};

export default WhyChoose;